import React, { Component } from "react";

class privacypolicy extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {};
  }

  render() {
    return (
      <div>
        <center>
          <h1>{`Privacy Policy`}</h1>
        </center>
        <br></br>
        <br></br>

        <center>
          <div
            name="termly-embed"
            data-id="106fc947-9fdc-41c3-9cc0-124bb9f6bcde"
            data-type="iframe"
          ></div>
          <script type="text/javascript">
            {(function (d, s, id) {
              var js,
                tjs = d.getElementsByTagName(s)[0];
              if (d.getElementById(id)) return;
              js = d.createElement(s);
              js.id = id;
              js.src = "https://app.termly.io/embed-policy.min.js";
              tjs.parentNode.insertBefore(js, tjs);
            })(document, "script", "termly-jssdk")}
          </script>
        </center>
      </div>
    );
  }
}

export default privacypolicy;
